import type { ECGlobal, ECMaquetteRequest } from '@/types/maquette'

export const EC_PEDAGOGICAL_FIELDS = [
  'intitule',
  'coefficient',
  'matiere_id',
  'volume_cm',
  'volume_td',
  'volume_tp',
  'volume_tpe',
  'volume_vht',
  'volume_effectif',
] as const

export function snapshotEcFromGlobal(global: ECGlobal): Record<string, string | number | null> {
  return {
    intitule: global.intitule,
    coefficient: global.coefficient,
    matiere_id: global.matiere_id,
    volume_cm: global.volume_cm ?? 0,
    volume_td: global.volume_td ?? 0,
    volume_tp: global.volume_tp ?? 0,
    volume_tpe: global.volume_tpe ?? 0,
    volume_vht: global.volume_vht ?? 0,
    volume_effectif: global.volume_effectif ?? 0,
  }
}

export function pedagogicalEcPayload(ec: Record<string, any>): Record<string, any> {
  const payload: Record<string, any> = {}
  for (const field of EC_PEDAGOGICAL_FIELDS) {
    if (ec[field] === undefined) {
      continue
    }
    if (ec[field] === null && field !== 'matiere_id') {
      continue
    }
    payload[field] = ec[field]
  }
  return payload
}

export function displayEcIntitule(
  ec: Record<string, any> | null | undefined,
  fallback = ''
): string {
  if (!ec) return fallback
  const local = String(ec.intitule ?? '').trim()
  if (local) return local
  const catalogue = String(ec.ec_global?.intitule ?? ec.ecGlobal?.intitule ?? '').trim()
  if (catalogue) return catalogue
  return fallback
}

export function displayEcMatiere(ec: Record<string, any> | null | undefined): string {
  if (!ec) return ''
  return String(
    ec.matiere?.intitule
    ?? ec.ec_global?.matiere?.intitule
    ?? ec.ecGlobal?.matiere?.intitule
    ?? ''
  ).trim()
}

export function mapEcMaquetteForForm(ec: Record<string, any>): ECMaquetteRequest {
  return {
    id: ec.id,
    code: ec.code,
    intitule: ec.intitule,
    ec_global_id: ec.ec_global_id,
    ue_id: ec.ue_id ?? null,
    personnel_id: ec.personnel_id,
    evaluation_progressive: ec.evaluation_progressive ?? 40,
    evaluation_finale: ec.evaluation_finale ?? 60,
    is_active: ec.is_active,
    coefficient: ec.coefficient ?? 1,
    matiere_id: ec.matiere_id ?? null,
    volume_cm: ec.volume_cm ?? 0,
    volume_td: ec.volume_td ?? 0,
    volume_tp: ec.volume_tp ?? 0,
    volume_tpe: ec.volume_tpe ?? 0,
    volume_vht: ec.volume_vht ?? 0,
    volume_effectif: ec.volume_effectif ?? 0,
    _snapshotGlobalId: ec.ec_global_id,
  } as ECMaquetteRequest
}

export function emptyEcMaquette(): ECMaquetteRequest {
  return {
    ec_global_id: 0,
    ue_id: null,
    personnel_id: null,
    evaluation_progressive: 40,
    evaluation_finale: 60,
    is_active: true,
    coefficient: 1,
    intitule: '',
    matiere_id: null,
    volume_cm: 0,
    volume_td: 0,
    volume_tp: 0,
    volume_tpe: 0,
    volume_vht: 0,
    volume_effectif: 0,
  }
}

export function recalcEcVht(ec: { volume_cm?: number; volume_td?: number; volume_tp?: number; volume_tpe?: number; volume_vht?: number }) {
  ec.volume_vht = (Number(ec.volume_cm) || 0) + (Number(ec.volume_td) || 0) + (Number(ec.volume_tp) || 0) + (Number(ec.volume_tpe) || 0)
}
